module.exports = __webpack_public_path__ + "media/images/pin-new-store-21ac4af5a1badd1ee778242a052976a5.png";